import { CropStyleFillPattern } from "@omnia/shared/generated/enums";
import { RGBColor } from "@omnia/shared/types";
import { resolveState } from "../changes";
import { CropStyle } from "../types";
import { CropPurposeRows } from "./CropPurposeRows";
import { CropVarietyRows } from "./CropVarietyRows";
import { DescriptionRows } from "./DescriptionRows";
import { GrassRows } from "./GrassRows";
import { StyleRow } from "./StyleRow";

export interface CropRowProps {
    cropItem: CropStyle;
    setCropItem: React.Dispatch<React.SetStateAction<CropStyle>>;
}

export const CropRow = ({ cropItem, setCropItem }: CropRowProps) => {
    const hasVarieties = !!cropItem.varieties.length;
    const hasPurposes = !!cropItem.purposes.length;
    const hasGrasses = !!cropItem.grasses.length;
    const hasDescriptions = !!cropItem.descriptions.length;
    const isExpandable = hasVarieties || hasPurposes || hasGrasses || hasDescriptions;

    const [isExpanded, setExpanded] = React.useState<boolean>(false);

    const effectiveColor: RGBColor = cropItem.color ?? cropItem.defaultStyle.color;
    const effectivePattern: CropStyleFillPattern = cropItem.pattern ?? cropItem.defaultStyle.pattern;

    return (
        <>
            <StyleRow
                className="crop"
                effectiveStyle={{ color: effectiveColor, pattern: effectivePattern }}
                initialStyle={{ color: cropItem.initialState.color, pattern: cropItem.initialState.pattern }}
                selectedStyle={{ color: cropItem.color, pattern: cropItem.pattern }}
                label={cropItem.name}
                typeLabel="Crop"
                onChange={(style) =>
                    setCropItem((prev) => ({
                        ...prev,
                        ...resolveState({ color: prev.color, pattern: prev.pattern }, style),
                    }))
                }
                onToggle={() => setExpanded((prev) => !prev)}
                expanded={isExpandable ? isExpanded : undefined}
            >
                <CropPurposeRows setCropStyle={setCropItem} cropStyle={cropItem} />
                <GrassRows setCropStyle={setCropItem} cropStyle={cropItem} />
                <CropVarietyRows setCropStyle={setCropItem} cropStyle={cropItem} />
                <DescriptionRows setCropStyle={setCropItem} cropStyle={cropItem} />
            </StyleRow>
        </>
    );
};
